import React from 'react';
import { Link } from 'react-router-dom';

import logo from '../../images/logo-hub-powered-by-insureon.svg';

import style from './PublicHeader.module.css';

const PublicHeader = React.memo(() => {
  return (
    <header className={style.header}>
      <Link to="/">
        <img src={logo} alt="logo" />
      </Link>
    </header>
  );
});

export default PublicHeader;
